// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-input[data-v-0d414e6c]:disabled {\n  background-color: #fff !important;\n  color: #303438 !important;\n  cursor: auto !important;\n}\n.emd-select ._state_error[data-v-0d414e6c] {\n  border-color: var(--brand--le--danger-color--base, #df285f)\n}\n._mode_dark .emd-input[data-v-0d414e6c]:disabled {\n  background-color: transparent !important;\n  color: #c4c6c8 !important;\n  cursor: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
